import BootstrapRow from "root/ReactHookForm/ui/BootstrapRow";
import BootstrapCol from "root/ReactHookForm/ui/BootstrapCol";
import {FormInput, FormInputDatePicker} from "root/ReactHookForm/FormComponents";
import {ModalFutureAbsenceSectionsNames} from "root/s360components/Modals/FutureAbsence/ModalFutureAbsence";
import DropdownAbsenceCode, {getAbsenceCode} from "root/s360components/ReactHookForm/ui/DropdownAbsenceCode";
import {useAbsenceCodesContext} from "root/s360components/Contexts/AbsenceCodes/AbsenceCodesContext";
import TextAreaRegComment from "root/s360components/ReactHookForm/ui/TextAreaRegComment";
import DropdownAMPM, {ALL_SESSION_OBJ, AM_OBJ, PM_OBJ} from "root/s360components/ReactHookForm/ui/DropdownAMPM";
import {useEffect} from "react";
import {ModalFutureAbsenceModes} from "root/s360components/Modals/FutureAbsence/useModalFutureAbsence";

const FutureAbsenceEditFragment = ({sectionName, control, formErrors, setValue, register, selectedAbsenceCode}) =>
{

    const sessionOptions = [
        AM_OBJ,
        PM_OBJ,
        ALL_SESSION_OBJ
    ]

    const {absenceCodes, loadingAbsenceCodes} = useAbsenceCodesContext();

    useEffect(() =>
    {
        if (selectedAbsenceCode !== null && loadingAbsenceCodes === false)
        {
            setValue(ModalFutureAbsenceModes.EDIT + '.' + ModalFutureAbsenceSectionsNames.ABS_CODE, getAbsenceCode(selectedAbsenceCode, absenceCodes))
        }
    }, [selectedAbsenceCode, loadingAbsenceCodes])

    return (
        <form className='future-absence-edit-frag'>
            <BootstrapRow>
                <BootstrapCol width={6}>
                    <label className='form-label'>Username</label>
                    <FormInput register={register} sectionName={sectionName}
                               name={ModalFutureAbsenceSectionsNames.FULL_NAME} formErrors={formErrors}
                               readOnly={true}/>
                </BootstrapCol>
                <BootstrapCol width={6}>
                    <label>Select a reason</label>
                    <DropdownAbsenceCode absenceCodes={absenceCodes} loadingAbsenceCodes={loadingAbsenceCodes}
                                         control={control}
                                         fieldName={sectionName + '.' + ModalFutureAbsenceSectionsNames.ABS_CODE}/>
                </BootstrapCol>
            </BootstrapRow>
            <BootstrapRow>
                <BootstrapCol width={6}>
                    <FormInputDatePicker control={control} sectionName={sectionName}
                                         name={ModalFutureAbsenceSectionsNames.ABS_FROM}
                                         formErrors={formErrors} readOnly={false} label={'From'}/>
                </BootstrapCol>
                <BootstrapCol width={6}>
                    <FormInputDatePicker control={control} sectionName={sectionName}
                                         name={ModalFutureAbsenceSectionsNames.ABS_TO}
                                         formErrors={formErrors} readOnly={false} label={'To'}/>
                </BootstrapCol>
            </BootstrapRow>
            <BootstrapRow>
                <BootstrapCol width={6}>
                    <label>Select a session</label>
                    <DropdownAMPM control={control}
                                  name={sectionName + '.' + ModalFutureAbsenceSectionsNames.SESSION}
                                  readOnly={false} placeholder={"Please select a time"} options={sessionOptions}/>
                </BootstrapCol>
                <BootstrapCol width={6}>
                    <label>Notes</label>
                    <TextAreaRegComment control={control}
                                        fieldName={sectionName + '.' + ModalFutureAbsenceSectionsNames.NOTES}/>
                </BootstrapCol>
            </BootstrapRow>
        </form>
    )
}

export default FutureAbsenceEditFragment;